import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { MdOutlineChangeCircle, MdOutlineDataSaverOn } from "react-icons/md";

const CommonModal = ({
    show,
    handleClose,
    handleSave,
    mode,
    columns,
    data,
    handleChange,
    errors,
    title = '',
    saveButtonText = '',
    icon,
    modalPosition = true,
    isChanged = true,
    isSaving = false
}) => {
    const filteredColumns = columns?.filter((col) => col.accessor !== 'id');

    const renderField = (col) => {
        const fieldType = col.type || 'text';

        switch (fieldType) {
            case 'checkbox': {
                const checkboxId = `checkbox-${col.accessor}`;

                return (
                    <Form.Check className="custom-dark-checkbox">
                        <Form.Check.Input
                            type="checkbox"
                            id={checkboxId}
                            name={col.accessor}
                            checked={!!data[col.accessor]}
                            onChange={handleChange}
                            disabled={mode === 'view'}
                            isInvalid={!!errors[col.accessor]}
                            className='cursor-pointer'
                        />

                        <Form.Check.Label className='cursor-pointer' htmlFor={checkboxId}>
                            {col.header}
                        </Form.Check.Label>
                    </Form.Check>
                );
            }


            case 'number':
                return (
                    <Form.Control
                        type="number"
                        name={col.accessor}
                        value={data[col.accessor] ?? ''}
                        onChange={handleChange}
                        placeholder={col.header}
                        isInvalid={!!errors[col.accessor]}
                        disabled={mode === 'view'}
                    />
                );

            case 'textarea':
                return (
                    <Form.Control
                        as="textarea"
                        rows={3}
                        name={col.accessor}
                        value={data[col.accessor] ?? ''}
                        onChange={handleChange}
                        placeholder={col.header}
                        isInvalid={!!errors[col.accessor]}
                        disabled={mode === 'view'}
                    />
                );

            case 'select': {
                // col.options expected: array of strings OR array of { value, label }
                const options = col.options || [];
                return (
                    <Form.Select
                        name={col.accessor}
                        value={data[col.accessor] ?? ''}
                        onChange={handleChange}
                        disabled={mode === 'view'}
                        isInvalid={!!errors[col.accessor]}
                    >
                        {col.placeholder && <option value="">{col.placeholder}</option>}
                        {options.map((opt) =>
                            typeof opt === 'string' ? (
                                <option key={opt} value={opt}>
                                    {opt}
                                </option>
                            ) : (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            )
                        )}
                    </Form.Select>
                );
            }

            default:
                return (
                    <Form.Control
                        type="text"
                        name={col.accessor}
                        value={data[col.accessor] ?? ''}
                        onChange={handleChange}
                        placeholder={col.header}
                        disabled={mode === 'view'}
                        isInvalid={!!errors[col.accessor]}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                if (!isSaving && (mode !== 'edit' || isChanged)) {
                                    handleSave();
                                }
                            }
                        }}
                    />
                );
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" centered={modalPosition}
            dialogClassName="custom-modal"
        >
            <Modal.Header closeButton className=' !m-0 !border-none'>
                <Modal.Title className='!font-semibold !text-2xl'>
                    {mode === 'add' && 'Add'}
                    {mode === 'edit' && 'Update'}
                    {mode === 'view' && 'View'}
                    {mode === 'other' && title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="!py-0">
                {mode === 'view' ? (
                    <div>
                        {filteredColumns?.map((col) => (
                            <p key={col.accessor}>
                                <strong>{col.header}: </strong>
                                {String(data[col.accessor] ?? '')}
                            </p>
                        ))}
                    </div>
                ) : (
                    <Form>
                        {filteredColumns?.map((col) => (
                            <Form.Group key={col.accessor} className="mb-3">
                                {renderField(col)}
                                {errors[col.accessor] && (
                                    <Form.Control.Feedback type="invalid">{errors[col.accessor]}</Form.Control.Feedback>
                                )}
                            </Form.Group>
                        ))}
                    </Form>
                )}
            </Modal.Body>

            <Modal.Footer className="flex !justify-start !m-0 !border-none !pt-0">
                {mode !== 'view' && (
                    <button
                        className="flex items-center !bg-[#AEF468] !border-none !text-sm text-black  !px-[16px] !py-4 h-[30px] !font-bold !rounded-[4px]"
                        onClick={handleSave}
                        disabled={(mode === 'edit' && !isChanged) || isSaving}
                    >
                        {isSaving ? (
                            <>
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900 !mr-1"></div>

                            </>
                        ) : (
                            saveButtonText ? <>{icon} {saveButtonText}</> : mode === 'edit' ? <>Update</> : <>Add</>
                        )}
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default CommonModal;
